module.exports = __webpack_public_path__ + "img/closeicon.cba2da8e.svg";